import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import './playlist-state-modal.scss';
import {Modal} from '../../modal/modal';
import {translations} from '../../../i18n/translations';
import {CaregiverMode} from '../../../enums';

type PlaylistStateModalProps = {
  open: boolean;
  playlistName: string;
  state: 'enable' | 'disable';
  caregiverMode: CaregiverMode;
  userName: string;
  entityName: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const PlaylistStateModal = ({
  open,
  playlistName,
  state,
  entityName,
  caregiverMode,
  userName,
  onClose,
  onConfirm,
}: PlaylistStateModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      className="playlists-state-modal"
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      preventCloseClick
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.confirm),
          type: 'nondestructive',
          onClick: onConfirm,
        },
      ]}
    >
      <Stack>
        <Typography className="title">
          {t(translations.user_playlists[`${state}_playlist_dialog_title`], {
            name: playlistName,
          })}
        </Typography>
        <Typography className="subtitle">
          {caregiverMode === CaregiverMode.SystemAdministrator
            ? t(translations.user_playlists[`${state}_playlist_for_entity_dialog_message`], {
                name: userName,
                entity: entityName,
              })
            : t(translations.user_playlists[`${state}_playlist_dialog_message`], {
                name: userName,
              })}
        </Typography>
      </Stack>
    </Modal>
  );
};
